import { getUser } from './getUser'

export const getToken = () => getUser()?.access_token
